<template>
<b-container
  class="py-5 d-flex section"
  style="background-color: #08034c;" 
  fluid
  >
  <b-row class="justify-content-center align-self-center mx-auto">
    <b-col>
      
      <b-container class="p-5 text-light" fluid>
	<b-row class="text-center">
	  <b-col cols="12" lg="6" offset-lg="3">
	    <div class="p-lg-5">
	      <h2>"There is no reason IT corporations should control your data, 
		or for your data to be locked into one app."</h2>
	    </div>
	  </b-col>
	</b-row>
	<b-row>
	  <b-col cols="12" lg="4" offset-lg="4">
	    <div class="py-5 mx-auto text-left">
	      <p>Do you have single purpose apps that lock your data into siloed use?</p>
	      
	      <p>Do you have data, like contact names, siloed into one app that you either have to synchronise or duplicate into other apps?</p>
	      
	      <p>Do you have systems that are difficult to move away from, because your data is stuck in them?</p>
	    </div>
	  </b-col>
	</b-row>
      </b-container>
      
    </b-col>
  </b-row>
</b-container>
</template>

<script>
export default {
    name: "ItShouldntControl"
}
</script>
